module.exports = __webpack_public_path__ + "img/CORONA_BUEN_ESTADO.png";